import { createActorContext } from '@xstate5/react'
import { quizMachine } from './machine'

export const QuizMachineContext = createActorContext(quizMachine)
